/** URL / filter id for stocks with no sector. */
export const UNASSIGNED_SECTOR_ID = "__unassigned__";

/**
 * @param {string|null|undefined} sector
 * @returns {string}
 */
export function normalizeStockSectorId(sector) {
  const trimmed = sector != null ? String(sector).trim() : "";
  return trimmed ? trimmed : UNASSIGNED_SECTOR_ID;
}

/**
 * @param {string|null|undefined} sector
 * @returns {string}
 */
export function getStockSectorLabel(sector) {
  const trimmed = sector != null ? String(sector).trim() : "";
  return trimmed || "Unassigned";
}

/**
 * @param {Array<{ sector?: string|null, equity?: number|string|null }>} stocks
 */
export function buildStockSectorBreakdown(stocks) {
  const byId = new Map();

  for (const stock of stocks || []) {
    const id = normalizeStockSectorId(stock?.sector);
    const label = getStockSectorLabel(stock?.sector);
    if (!byId.has(id)) {
      byId.set(id, { id, label, rangeLabel: "", count: 0, investment: 0 });
    }
    const row = byId.get(id);
    row.count += 1;
    const equity = Number(stock?.equity);
    if (Number.isFinite(equity)) row.investment += equity;
  }

  const segments = Array.from(byId.values()).sort((a, b) => {
    if (b.count !== a.count) return b.count - a.count;
    return a.label.localeCompare(b.label);
  });

  const total = segments.reduce((sum, s) => sum + s.count, 0);
  const totalInvestment = segments.reduce((sum, s) => sum + s.investment, 0);

  return {
    missing: 0,
    total,
    totalInvestment,
    segments: segments.map((s) => ({
      ...s,
      pct: total > 0 ? (s.count / total) * 100 : 0,
      investmentPct: totalInvestment > 0 ? (s.investment / totalInvestment) * 100 : 0,
    })),
  };
}
